import getConfig from 'next/config';

export default function chooseNDPScript() {
  const {
    publicRuntimeConfig: {
      // URL to latest NDP script
      NDP_URL: ndpURL = 'https://media1.s-nbcnews.com/i/videoassets/ndp/latest/',
      NDP_HLS_BUILD = 'ndp-hls',
    },
  } = getConfig();

  let {
    publicRuntimeConfig: {
      NDP_BASE_BUILD: playerBuild = 'ndp',
    },
  } = getConfig();

  // Init vars to test browser capabilities that determine what NDP build to load
  const MediaSource = window.MediaSource || window.WebKitMediaSource;
  const video = document.createElement('video');

  // Test browser capabilities, and return appropriate build
  if (MediaSource && !video.canPlayType('application/x-mpegURL').length) {
    playerBuild = NDP_HLS_BUILD;
  }

  return `${ndpURL}${playerBuild}.js`;
}
